export enum AnimationEventType {
  Tick = 'tick'
}
